import { render, staticRenderFns } from "./InvoiceReferenceItem.yaml?vue&type=template&id=474907f3&component"
import script from "./InvoiceReferenceItem.yaml?vue&type=script&lang=ts&component"
export * from "./InvoiceReferenceItem.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports